import React from 'react';
import PropTypes from 'prop-types';
import PayTimeWarningStep from '../../../../util_components/pay_time_warning';

// A-52, series and pause cancels: one acknowledgement (one note) for every Care record goserver
// refused with PAY_TIME_WARNING. "Skip for now" leaves them listed under the page's warning.
export default function CareBatchWarningStep({ retry, busy, onAcknowledge, onSkip }) {
  const uuids = retry.retry.map((f) => f.session_uuid);
  return (
    <div data-testid="care-batch-warning">
      <h5>The request time is not saved yet</h5>
      <p className="myt-form-help">
        The cancel went through. Check the request time for {uuids.length} class(es):{' '}
        {uuids.join(', ')}
      </p>
      <PayTimeWarningStep
        warning={retry.warning}
        busy={busy}
        changeLabel="Skip for now"
        onAcknowledge={(ack) => onAcknowledge(ack.note)}
        onChange={onSkip}
      />
    </div>
  );
}

CareBatchWarningStep.propTypes = {
  // plan_care_retry(...) with at least one record to retry
  retry: PropTypes.shape({
    retry: PropTypes.arrayOf(PropTypes.shape({ session_uuid: PropTypes.string })).isRequired,
    warning: PropTypes.object.isRequired
  }).isRequired,
  busy: PropTypes.bool,
  // called with the acknowledgement note
  onAcknowledge: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
};

CareBatchWarningStep.defaultProps = {
  busy: false
};
